import moment from "moment-timezone";

/**
 * Returns the deadline state of a notification:
 * - "overdue": deadline already passed (daysLeft < 0)
 * - "warning": deadline within the next 1 day (daysLeft <= 1)
 * - null: no deadline or already resolved
 */
export function deadlineState(notification) {
  if (!notification.deadline || notification.resolved_at > 0) {
    return null;
  }

  const today = moment().tz("America/Sao_Paulo").startOf("day");
  const deadline = moment
    .tz(notification.deadline, "YYYY-MM-DD")
    .startOf("day");
  const daysLeft = deadline.diff(today, "days");

  if (daysLeft < 0) {
    return "overdue";
  }

  if (daysLeft <= 1) {
    return "warning";
  }

  return null;
}